// extracted by mini-css-extract-plugin
export var layoutContainer = "_j-0";
export var layoutContainerNoRounding = "_j-6";
export var layoutContainerOpen = "_j-5";
export var layoutContainerResizing = "_j-1";
export var mainContent = "_j-2";
export var resizeDivider = "_j-3";
export var slidePanel = "_j-4";